<template>
  <div>
    <div class="d-flex justify-space-between align-baseline">
      <div class="d-flex flex-column align-start flex-md-row align-md-center">
        <div class="heading-4">Portfolio Performance</div>
        <v-divider class="mx-5 d-none d-md-block" vertical></v-divider>
        <div class="btn-badge active text-6 black--text font-weight-medium">
          {{ walletSelected.address ? walletSelected.label : "All Wallets" }}
        </div>
        <v-divider class="mx-5 d-none d-md-block" vertical v-if="isAuthenticated"></v-divider>
        <v-menu transition="slide-y-transition" bottom offset-y v-if="isAuthenticated">
          <template v-slot:activator="{ on, attrs }">
            <div class="c-btn-download" v-bind="attrs" v-on="on">
              <div class="d-flex align-center">
                <span class="darkgray--text">Download History</span>
                <img class="ml-1" src="@/assets/icons/export-csv.svg" alt="" />
              </div>
            </div>
          </template>
          <div class="rounded-8 pa-2">
            <div
              class="download-action darkgray--text text-6 has-hover-effect flex-1 pa-2 rounded-8"
              @click="downloadBalanceHistory('defi-assets')"
            >
              DeFi Assets
            </div>
            <div
              class="download-action darkgray--text text-6 has-hover-effect flex-1 pa-2 rounded-8 mt-2"
              @click="downloadBalanceHistory('pos-assets')"
            >
              Proof-of-Stake Assets
            </div>
          </div>
        </v-menu>
      </div>
      <div
        class="text-6 line-height-25 gray--text clickable"
        @click="chartExpanded = !chartExpanded"
      >
        <div v-if="chartExpanded" class="d-flex align-center">
          <span>Collapse Chart</span>
          <v-icon color="gray--text" small>mdi-chevron-up</v-icon>
        </div>
        <div v-else class="d-flex align-center">
          <span>Expand Chart</span>
          <v-icon color="gray--text" small>mdi-chevron-down</v-icon>
        </div>
      </div>
    </div>
    <performance-chart :chartExpanded="chartExpanded" />
    <vaults-assets class="mt-10" />
    <stake-assets class="mt-10" />
    <c-loading v-if="loadingData" :size="36" :width="3"></c-loading>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import PerformanceChart from "./components/PerformanceChart";
import VaultsAssets from "./components/VaultsAssets";
import StakeAssets from "./components/StakeAssets";
import { regsiterVuexModules } from "@/common/lib/utils";
import store from "@/store";
import portfolioModule from "@/store/modules/portfolio.module";
regsiterVuexModules(store, { portfolio: portfolioModule });

export default {
  components: {
    PerformanceChart,
    VaultsAssets,
    StakeAssets,
  },
  computed: {
    ...mapGetters({
      isAuthenticated: "auth/isAuthenticated",
      walletSelected: "userWallets/walletSelected",
      walletList: "userWallets/walletList",
      authUser: "auth/user",
    }),
  },
  data: () => ({
    chartExpanded: true,
    loadingData: false,
    downloading: false,
  }),
  methods: {
    async loadData() {
      if (!this.isAuthenticated) return;
      this.loadingData = true;
      await Promise.all([this.$store.dispatch("portfolio/fetchAUM")]);
      this.loadingData = false;
    },
    async downloadBalanceHistory(type) {
      if (this.downloading) return;
      this.downloading = true;
      const action =
        type === "defi-assets"
          ? "getCsvDataForBalanceHistory"
          : "getCsvDataForStakeBalanceHistory";
      const data = await this.$store.dispatch(`portfolio/${action}`);
      this.downloading = false;
      const a = window.document.createElement("a");
      a.href = window.URL.createObjectURL(
        new Blob([data], { type: "text/csv" })
      );
      a.download = `${type}-balance-history.csv`;
      document.body.appendChild(a);
      a.click();
      document.body.removeChild(a);
    },
  },
  watch: {
    walletSelected: {
      immediate: true,
      handler() {
        this.loadData();
      },
    },
    ["walletList.result"]() {
      this.loadData();
    },
  },
};
</script>

<style lang="scss" scoped>
.c-btn-download {
  border-radius: 8px;
  font-size: 12px;
  border: 1px solid #f2f2f2;
  padding: 4px 8px;
}
</style>
